export const GET_TESTIMONIALS = 'GET_TESTIMONIALS'
